import { useCallback, useState } from 'react';

export const useToggle = <A = false, B = true>(a = false as A, b = true as B): [A | B, () => void] => {
  const [toggle, setToggle] = useState<A | B>(a);
  return [toggle, useCallback(() => setToggle(ab => (ab === a ? b : a)), [a, b, setToggle])];
};
